import { useDeviceType } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getCurrentTab } from '../../selectors/tabs';
import { ETabs } from '../../types/redux/tabs';
import { trackOpenCard } from './tracking';

export function useOpenCard() {
  const currentTab = useSelector(getCurrentTab);
  const deviceType = useDeviceType();

  return useCallback(
    (id: number) => {
      const path = currentTab === ETabs.Realtors ? '/agents/' : '/company/';

      trackOpenCard(currentTab);

      if (deviceType !== 'desktop') {
        window.open(`${path}${id}`, '_self');
      }

      window.open(`${path}${id}`);
    },
    [currentTab, deviceType],
  );
}
